import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import {
  Btn,
  HeaderText,
  OcorrenciasDropdown,
  ThreeDots,
  UploadMultFileBtn,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useSobras, { LOAD_MESSAGE } from './SobrasHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { connect } from 'react-redux'
import ModalFotosOcorrencias from '../../ResumoSeparacaoManual/ModalFotosOcorrencias/ModalFotosOcorrencias'
import {
  urlFotosSobra,
  urlUploadFotoSobra,
} from '../../../../../services/api/routes/picking.routes'
import { isRouteAllowed } from '../../../../../services/permission/menus'
import { getResumoSeparacaoQuantidadeFracionada } from '../quantity-fracionada.helper'
import ModalAjusteOcorrenciaSobra from './ModalAjusteOcorrenciaSobra'

const AJUSTE_OCORRENCIA_PERMISSION = 145

function Sobras({ sobrasItems, reasons, selectedPicking, dispatch, onAjustado = () => {} }) {
  const { state, localDispatch } = useSobras()
  const canAdjustOcorrencia = isRouteAllowed(AJUSTE_OCORRENCIA_PERMISSION)
  const tableItems = state.sobrasItems || sobrasItems
  const menuItems = ['Ajuste da Ocorrência']

  const renderQuantidadeCell = (sobra, field, type) => {
    const quantidade = getResumoSeparacaoQuantidadeFracionada(sobra, field)
    const value = type === 'volume' ? quantidade.volumeText : quantidade.unitsText
    const label = type === 'volume' ? quantidade.volumeLabel : quantidade.unitsLabel
    const defaultLabel = type === 'volume' ? 'Vol.' : 'Frac.'

    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontWeight: 600 }}>{value}</div>
        {label !== defaultLabel ? (
          <div style={{ fontSize: '0.72rem', marginTop: 2 }}>{label}</div>
        ) : null}
      </div>
    )
  }

  const getAdjustedQuantityField = sobra => {
    return sobra.qte_leftover_adjusted !== undefined ? 'qte_leftover_adjusted' : 'qte_leftover'
  }

  const handleMenuClick = (menuItem, sobra) => {
    if (menuItem === 'Ajuste da Ocorrência') {
      localDispatch.onAjusteOcorrenciaClicked(sobra)
    }
  }

  const onAjusteOcorrenciaSaved = () => {
    localDispatch.onAjusteOcorrenciaModalClose()
    onAjustado()
  }

  useEffect(() => {
    localDispatch.onInit(selectedPicking, sobrasItems)
  }, [sobrasItems, selectedPicking])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.ASSOCIANDO:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.associateOcorrencias(tableItems, selectedPicking.id)
        break
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox('Ocorrências associadas com sucesso', null))
        localDispatch.resetState()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const codigoColWidth =
    tableItems && tableItems.length > 0
      ? Math.max(130, Math.max(...tableItems.map(s => (s.product_code || '').length)) * 9)
      : 130

  const content = (
    <div>
      <HeaderText>Listagem das Sobras Apuradas</HeaderText>
      <div style={{ marginTop: 10, marginBottom: 25 }}>
        <Btn disabled={state.btnAssociarDisabled} onClick={localDispatch.onBtnClicked}>
          Associar Ocorrência(s)
        </Btn>
      </div>
      <div className="main_container">
        <DataTable value={tableItems} style={{ tableLayout: 'fixed', width: '100%' }}>
          <Column
            field="product_code"
            header="Código"
            style={{
              ...tableCellCentered(codigoColWidth),
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          />
          <Column
            field="product_name"
            header="Produto"
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          />
          <Column
            header="Vol."
            style={tableCellCentered(110)}
            body={sobra => renderQuantidadeCell(sobra, getAdjustedQuantityField(sobra), 'volume')}
          />
          <Column
            header="Frac."
            style={tableCellCentered(110)}
            body={sobra => renderQuantidadeCell(sobra, getAdjustedQuantityField(sobra), 'units')}
          />
          <Column field="user_name" header="Apurado por" style={tableCellCentered(100)} />
          <Column
            header="Ocorrência"
            style={tableCellCentered(320)}
            body={sobra => {
              return (
                <OcorrenciasDropdown
                  disabled={state.btnAssociarDisabled}
                  style={{ width: '100%' }}
                  optionLabel="name"
                  value={sobra.missing_reason}
                  options={reasons}
                  appendTo={document.body}
                  onChange={({ value }) => localDispatch.onDropdownChange(sobra, value)}
                  placeholder="Selecione o Tipo de Ocorrência"
                />
              )
            }}
          />
          <Column
            header="Fotos"
            body={sobra => (
              <Btn
                onClick={() => localDispatch.onVerFotosClicked(sobra)}
                disabled={!sobra.files.length}
              >
                Ver Fotos ({sobra.files.length})
              </Btn>
            )}
            style={tableCellCentered(120)}
          />
          <Column
            header=""
            style={tableCellCentered(160)}
            body={sobra => (
              <div style={{ position: 'relative', top: '-20px' }}>
                <UploadMultFileBtn
                  label="Anexar Fotos"
                  name="sobras"
                  accept="image/*"
                  url={urlUploadFotoSobra()}
                  onUploadCompleted={file_name =>
                    localDispatch.onUploadCompleted(file_name, sobra, selectedPicking.id)
                  }
                />
              </div>
            )}
          />
          {canAdjustOcorrencia ? (
            <Column
              header="Menu"
              style={tableCellCentered(60)}
              body={sobra => (
                <ThreeDots
                  items={menuItems}
                  onClick={menuItem => handleMenuClick(menuItem, sobra)}
                />
              )}
            />
          ) : null}
        </DataTable>
      </div>
      <ModalFotosOcorrencias
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        data={state.modal.data}
        selectedPicking={selectedPicking}
        onDelete={localDispatch.onDeleteFoto}
        urlFoto={urlFotosSobra}
      />
      <ModalAjusteOcorrenciaSobra
        show={state.ajusteOcorrenciaModal.show}
        sobra={state.ajusteOcorrenciaModal.sobra}
        reasons={reasons}
        onClose={localDispatch.onAjusteOcorrenciaModalClose}
        onSaved={onAjusteOcorrenciaSaved}
        onError={error => dispatch(showMessageBox(null, error))}
      />
    </div>
  )
  return tableItems && tableItems.length > 0 ? content : <p>Não existem Sobras</p>
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({
  selectedPicking,
})

export default connect(mapStateToProps)(Sobras)
